import { VhcRecordLogService } from 'api/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useArticleByCodeQueryKey = 'ArticleByCodeQueryKey';

export type GetVhcRecordInput = {
  id: number;
};

const itemsTypes = {
  default: 'default',
  brake: 'brake',
  wheelTyre: 'wheelTyre'
};

const fetchVhcRecord = async (input: GetVhcRecordInput) => {
  const data = await VhcRecordLogService.getVhcRecords1(input.id);

  const { checkItems, checkBrakeItems, checkWheelTyreItems, ...generalData } = data || {};

  const items = [
    ...(checkItems?.map((item) => ({
      ...item,
      formType: itemsTypes.default
    })) ?? []),
    ...(checkBrakeItems?.map((item) => ({
      ...item,
      formType: itemsTypes.brake
    })) ?? []),
    ...(checkWheelTyreItems?.map((item) => ({
      ...item,
      formType: itemsTypes.wheelTyre
    })) ?? [])
  ];

  return {
    generalData,
    items: items.length > 0 ? items : null
  };
};

export const useGetVhcRecordQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input: GetVhcRecordInput,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchVhcRecord>>,
      QueryError,
      Awaited<ReturnType<typeof fetchVhcRecord>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([useArticleByCodeQueryKey, ...(queryKey ?? [{ ...input }])], () => fetchVhcRecord(input), options);
